function AccessOrNot(feature, check_limit = false, current_usage = 0,required_usage_data = false){
  // console.log("AccessOrNot called with feature:", feature, "check_limit:", check_limit, "current_usage:", current_usage);
    let user_plan = localStorage.getItem("planid")

    // console.log("planid" , user_plan)

    if (check_limit == true){
      let limits = {
        "trigger_words":{
          "free":3,
          "starter-one": 3,
          "starter-quart": 3,
          "starter-year": 3,
        },
        "reply_comments":{
          "free":3,
          "starter-one": 3,
          "starter-quart": 3,
          "starter-year": 3,
          "legend-two-month":3,
        },
        "button_template":{
          "starter-quart": 1,  
          "starter-one": 1,
          "starter-year": 1,
            "legend-two-month":2
        },
        "posts_automation":{
            "free":5,
            "starter-one": 25,
            "starter-quart": 25,
            "starter-year": 25,
        },
        "next_post_automation":{
            "free":0,
            "starter-one": 0,
            "starter-quart": 0,
            "starter-year": 0,
            "legend-two-month":0,
            "566422":3,
            "000003":15,
            "428337":25


        },
      }

      // console.log(feature,"limit reached",((limits[feature] || {})[user_plan] || 10000) , current_usage , ((limits[feature] || {})[user_plan] || 10000) <= current_usage)
      if(required_usage_data){


      //   console.log("feature-=-=-=-",feature,((limits[feature] || {})[user_plan] || 10000) <= current_usage  ? {
      //     limit_reached: false,
      //     current_usage: current_usage,
      //     limit: ((limits[feature] || {})[user_plan] || "Unlimited")

      // } : {
      //     limit_reached: true,
      //     current_usage: current_usage,
      //     limit: ((limits[feature] || {})[user_plan] || "Unlimited")
      // })

        return ((limits[feature] || {})[user_plan] || 10000) <= current_usage  ? {
          limit_reached: false,
          current_usage: current_usage,
          limit: ((limits[feature] || {})[user_plan] || "Unlimited")

      } : {
          limit_reached: true,
          current_usage: current_usage,
          limit: ((limits[feature] || {})[user_plan] || "Unlimited")
      }
      
    }
      
      return ((limits[feature] || {})[user_plan] || 10000) <= current_usage  
    }
    // console.log("AccessOrNot called with feature:", feature, "user_plan:", user_plan);
    let features = {
      "story_automation":["legend-two-month","566420","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "next_post_automation":["566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "copy_previous_post": ["starter-quart","starter-year","legend-two-month","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "all_comment": ["legend-two-month","566420","566421","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "ai_reply_comments": ["legend-two-month","566420","566421","566422","566423","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "post_dm": ["428337","428338","202","2021","203","2031","204","2041","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "smart_mode": ["428337","428338","000003","0000031","202","2021","203","2031","204","2041","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "welcome_message":["starter-quart","starter-year","legend-two-month","566420","566421","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "follow_only":["starter-quart","starter-year","legend-two-month","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "button_template":["starter-quart","starter-year","legend-two-month","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "reply_delay":["starter-quart","starter-year","legend-two-month","566420","566421","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "flow_editor": ["5052712","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      "fb_automation": ["5052712","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041", "trendsetter-pro-monthly", "trendsetter-pro-yearly"],
      
    }

    // console.log("======FEATURE===" , (features[feature] || []) , user_plan , (features[feature] || []).includes(user_plan))

    if ((features[feature] || []).includes(user_plan)){
      return true
    }
    else{
      return false
    }
      
  }

  export default AccessOrNot;